import { Modal } from "@iq/models";
import "./OrphanedTicketModal.css";

export default function OrphanedTicketModal({
    orphan,
    isOpen,
    saving,
    error,
    onDelete,
    onLinkAnother,
    onClose,
}) {
    if (!isOpen || !orphan) {
        return null;
    }

    const isProblem = orphan.type === "problem";
    const ticketLabel = isProblem ? "Problem" : "Change";
    const relatedTicketLabel = isProblem ? "Incident" : "Problem";
    const ticketNumber = orphan.ticket?.number || `${ticketLabel.toUpperCase()}-${orphan.id}`;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={`Unlinked ${ticketLabel}`}
            errorMessage={error}
            actionButtons={[
                {
                    key: "orphan-do-nothing",
                    text: "Do Nothing",
                    color: "light",
                    onClick: onClose,
                    disabled: saving,
                },
                {
                    key: "orphan-link-another",
                    text: `Link Another ${relatedTicketLabel}`,
                    color: "accent",
                    onClick: onLinkAnother,
                    disabled: saving,
                },
                {
                    key: "orphan-delete",
                    text: saving ? `Deleting ${ticketLabel}...` : `Delete ${ticketLabel}`,
                    color: "danger",
                    onClick: onDelete,
                    disabled: saving,
                },
            ]}
        >
            <div className="orphaned-ticket-modal-body">
                <p>
                    <strong>{ticketNumber}</strong> no longer has any related tickets.
                </p>
                <p>
                    You can delete this {ticketLabel.toLowerCase()}, link another {relatedTicketLabel.toLowerCase()}, or leave it unlinked.
                </p>
            </div>
        </Modal>
    );
}